import RegisterForm from 'lib/data/forms/RegisterForm';
import { getInnerError } from 'lib/utils/adaya/AdayaUtils';
import React, { useState } from 'react';
import { Validation } from 'utils/Validation';
import FormRowEditField from './FormRowEditField';
import './style.scss';

const TEST_ACCOUNT = {
    name: 'My Account',
    providers: []
};
const ProfileForm = ({ auth }) => {
    const [accountName, setAccountName] = useState('');
    const [error, setError] = useState('');
    const [formErrors, setFormErrors] = useState({});

    const user = auth.user;
    const account = user?.activeAccount;

    const changePassword = () => {
        console.log('change password');
    }

    const deleteAccount = () => {
        if (confirm("Are you sure?")) {
            //return await AuthService.deleteAccount();
        }
    }

    const saveField = async (name, val, cb) => {
        try {
            setFormErrors({});
            setError('');

            let vr = Validation.validate({ [name]: val }, { [name]: RegisterForm.rules[name] });
            if (vr !== true) {
                if (cb) cb(false);
                return setFormErrors(vr);
            }

            // update the user...
            props.auth.updateUser(user)
                .then((r) => {
                    setUser(r);
                    if (cb) cb(true);
                })
                .catch((e) => {
                    setError("An error occurred.");
                    console.log('e', e)
                });
        } catch (e) {
            console.errir(`Error saving field:`, e);
            setError(getInnerError(e));
        }
    };

    const checkError = (field) => {
        let e = formErrors[field];
        if (e) {
            return e.error;
        }
    }

    if (!user) {
        return null;
    }

    return (
        <div className="profile-form card-panel">
            <div className="profile-form-header">
                <div className="avatar"></div>
                <div className="username">{user.name}</div>
            </div>
            <div className="profile-form-row">
                <FormRowEditField
                    error={checkError('accountName')}
                    label="Account Name"
                    placeholder="Account Name"
                    dark="true"
                    value={account.name}
                    onSave={(v, cb) => { saveField('accountName', v, cb); }}
                />
            </div>
            <div className="profile-form-row">
                <FormRowEditField
                    error={checkError('name')}
                    label="Full Name"
                    placeholder="Full Name"
                    dark="true"
                    value={user.name}
                    onSave={(v, cb) => { saveField('name', v, cb); }}
                />
            </div>
            <div className="profile-form-row">
                <FormRowEditField
                    error={checkError('email')}
                    label="Email"
                    type="email"
                    placeholder="Email"
                    dark="true"
                    value={user.email}
                    editable={false}
                />
            </div>
        </div>
    );
}

export default ProfileForm;